export default __webpack_public_path__ + "static/media/loading.d9b02833.svg";